import IPrice from '../../model/prices/IPrice';
import { usePersistedCurrencyPreference } from './usePersistedCurrencyPreference';
import usePlatformConfig from '../../../common/react/usePlatformConfig';
import { useMemo } from 'react';

const useFilterSelectedCurrencyPrice = (prices: IPrice[]): number | null => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const displayCurrency = (isSecondaryCurrencyDisplay ? priceDisplay.secondary : priceDisplay.primary).currency;

  const price = useMemo(
    () => prices.find(price => price.money.currency === displayCurrency),
    [prices, priceDisplay, isSecondaryCurrencyDisplay],
  );

  return price?.money.amount || null;
};

export default useFilterSelectedCurrencyPrice;
